import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { Observable, timer, Subject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

import { ConfigDto } from './api/configDto';
import { PriceDto } from './api/priceDto';
import { env } from '../environments/environment';
import { NGXLogger } from 'ngx-logger';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

@Injectable({providedIn: 'root'})
export class PriceService {
	readonly MIN_IN_MILLIS = 60000;
	priceUpdated$: Subject<any>;
	priceChangeIntervalMillis: number
	private priceScheduler: Observable<any>
	private config: ConfigDto

	constructor(
		private globalService: GlobalService,
		private log: NGXLogger) {
		this.priceUpdated$ = new Subject();
		this.globalService.config.subscribe(config => {
			this.config = config;
			this.priceChangeIntervalMillis = this.config.priceChangeInterval * this.MIN_IN_MILLIS;
			this.priceScheduler = timer(0, env.priceSchedulerFreqSecs * 1000);
		});
	}
/*
	calculateInitialDelay(remainingMins, priceChangeInterval) {
		if (remainingMins % priceChangeInterval === 0) {
			return priceChangeInterval;
		} else {
			return (remainingMins % priceChangeInterval);
		}
	}
*/

	getActualPrice(price: PriceDto, subscriber: OnDestroyMixin): Observable<number> {
		const {minsToEnd, end} = price;
		let {act} = price;
		const remainingPeriods = Math.floor(minsToEnd / this.config.priceChangeInterval);
		const priceInc = remainingPeriods > 0 ? (end - act) / remainingPeriods : 0;
		const startDate = new Date();
		let nextStep = startDate.getTime() + (minsToEnd % this.config.priceChangeInterval) * this.MIN_IN_MILLIS;
		this.log.debug('updatePrice: next:', new Date(nextStep).toISOString(), 'act:', act, 'priceInc:', priceInc);
		return this.priceScheduler
			.pipe(
			map(() => {
				if (act > 0 && priceInc !== 0) {
					const localDate = new Date();
					this.log.trace('updatePrice pipe: next:', new Date(nextStep).toISOString(), 'act:', act);
					if (nextStep < localDate.getTime()) {
						nextStep += this.priceChangeIntervalMillis;
						act += priceInc;
						if ((act < end && priceInc < 0)
							|| (act > end && priceInc > 0)) {
							act = 0; // TODO unsubscribe
						}
						this.log.trace('updatePrice upd: next:', new Date(nextStep).toISOString(), 'act:', act);
					}
				}
				price.act = act;
				return act;
			})
		,takeWhile(actPrice => actPrice > 0)
		,untilComponentDestroyed(subscriber));
	}
}